/** دسترسی به پاپ‌آپ تماس ورودی — فقط با فلگ دستی در تنظیمات کاربران. */
import { clearQueueLoginRole } from './queueLoginRole';

export function canAccessScreenPop(): boolean {
  return localStorage.getItem('admin_screen_pop_access') === '1';
}

export function setScreenPopAccessFromLogin(value: boolean | undefined | null): void {
  localStorage.setItem('admin_screen_pop_access', value ? '1' : '0');
}

export function clearScreenPopAccess(): void {
  localStorage.removeItem('admin_screen_pop_access');
  localStorage.removeItem('admin_phone_extension');
  sessionStorage.removeItem('admin_extension_confirmed');
  clearQueueLoginRole();
}

export function getStoredPhoneExtension(): string {
  return (localStorage.getItem('admin_phone_extension') || '').trim();
}

export function setStoredPhoneExtension(ext: string): void {
  localStorage.setItem('admin_phone_extension', (ext || '').trim());
}

export function isExtensionConfirmedThisSession(): boolean {
  return sessionStorage.getItem('admin_extension_confirmed') === '1';
}

export function setExtensionConfirmedThisSession(value: boolean): void {
  if (value) {
    sessionStorage.setItem('admin_extension_confirmed', '1');
  } else {
    sessionStorage.removeItem('admin_extension_confirmed');
  }
}
